/* jareko-easysell-fix.js — JS global JarekopaiT v5
   1) Override EasySell inline !important styles (verde confianza #00A650)
      - incluye transition:none para matar la transición colgada rojo->verde de EasySell
   2) Traducción/ajuste de etiquetas de filtros (API en inglés) */
(function() {
  'use strict';

  var GREEN = '#00A650';
  var GREEN_HOVER = '#008A45';
  var RED_RE = /#?FF0000|rgb\(\s*255\s*,\s*0\s*,\s*0\s*\)/i;

  function styleBtn(b, opts) {
    if (!b) return;
    /* Cortar cualquier transición/animación de color colgada de EasySell */
    b.style.setProperty('transition', 'none', 'important');
    b.style.setProperty('background', GREEN, 'important');
    b.style.setProperty('background-color', GREEN, 'important');
    b.style.setProperty('border', 'none', 'important');
    b.style.setProperty('border-color', GREEN, 'important');
    b.style.setProperty('color', '#ffffff', 'important');
    b.style.setProperty('border-radius', '8px', 'important');
    b.style.setProperty('font-weight', '700', 'important');
    b.style.setProperty('letter-spacing', '0.2px', 'important');
    b.style.setProperty('line-height', '1.2', 'important');
    if (opts.compact) {
      b.style.setProperty('font-size', '13px', 'important');
      b.style.setProperty('padding', '8px 8px', 'important');
      b.style.setProperty('min-height', '38px', 'important');
      b.style.setProperty('margin', '6px 0 0', 'important');
      b.style.setProperty('width', '100%', 'important');
      b.style.setProperty('box-shadow', '0 2px 8px rgba(0,166,80,0.20)', 'important');
    } else {
      b.style.setProperty('font-size', '17px', 'important');
      b.style.setProperty('box-shadow', '0 4px 14px rgba(0,166,80,0.28)', 'important');
    }
    /* Cancelar transiciones WAAPI/CSS activas de color */
    try {
      if (b.getAnimations) {
        b.getAnimations().forEach(function(a) {
          try {
            var kf = a.effect && a.effect.getKeyframes ? a.effect.getKeyframes() : [];
            var hasColor = kf.some(function(f){ return f.backgroundColor; });
            if (hasColor) a.cancel();
          } catch (e) {}
        });
      }
    } catch (e) {}
    if (!b.dataset.jkGreen) {
      b.addEventListener('mouseenter', function() {
        b.style.setProperty('background', GREEN_HOVER, 'important');
        b.style.setProperty('background-color', GREEN_HOVER, 'important');
      });
      b.addEventListener('mouseleave', function() {
        b.style.setProperty('background', GREEN, 'important');
        b.style.setProperty('background-color', GREEN, 'important');
      });
      b.dataset.jkGreen = '1';
    }
  }

  function applyGreen() {
    document.querySelectorAll('#es-popup-button, .es-popup-button').forEach(function(b) {
      var compact = !!(b.closest && b.closest('.card-wrapper, .card, li.grid__item, .quick-add'));
      styleBtn(b, { compact: compact });
    });
    document.querySelectorAll('#es-sticky, .es-sticky-btn, #es-form-button, .es-cta-btn').forEach(function(b) {
      styleBtn(b, { compact: false });
    });
  }

  /* ============================================
     Traducción/ajuste de filtros
     ============================================ */
  var I18N = {
    'availability': 'Disponibilidad',
    'price': 'Precio',
    'in stock': 'En stock',
    'out of stock': 'Agotado',
    'from': 'Desde',
    'to': 'Hasta',
    'de': 'Desde',
    'para': 'Hasta',
    'brand': 'Marca',
    'color': 'Color',
    'size': 'Tamaño',
    'product type': 'Tipo de producto',
    'more': 'Más',
    'less': 'Menos'
  };

  function translateNode() {
    var areas = document.querySelectorAll('.facets, .mobile-facets, .facets-container, facet-filters-form');
    Array.prototype.forEach.call(areas, function(area) {
      var walker = document.createTreeWalker(area, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = walker.nextNode())) {
        var raw = n.textContent;
        var key = raw.trim().toLowerCase();
        if (key && I18N[key]) {
          n.textContent = raw.replace(raw.trim(), I18N[key]);
        }
      }
      Array.prototype.forEach.call(area.querySelectorAll('input[placeholder]'), function(inp) {
        var p = (inp.getAttribute('placeholder') || '').trim().toLowerCase();
        if (I18N[p]) inp.setAttribute('placeholder', I18N[p]);
      });
    });
  }

  function applyAll() {
    applyGreen();
    try { translateNode(); } catch (e) {}
  }

  var pending = null;
  var observer = new MutationObserver(function(mutations) {
    var needsFix = false;
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var node = m.addedNodes[j];
        if (node.nodeType === 1) {
          if (/^es-/.test(node.id || '') ||
              (node.querySelector && node.querySelector('[id^=es-], .es-cta-btn, .es-popup-button, .facets, .mobile-facets'))) {
            needsFix = true;
          }
          if (node.classList && (node.classList.contains('facets') || node.classList.contains('mobile-facets'))) needsFix = true;
        }
      }
      if (m.type === 'attributes' && m.attributeName === 'style' && m.target && ((m.target.id && /^es-/.test(m.target.id)) || (m.target.classList && m.target.classList.contains('es-popup-button')))) {
        if (RED_RE.test(m.target.getAttribute('style') || '')) needsFix = true;
      }
    }
    if (needsFix && !pending) {
      pending = setTimeout(function() {
        pending = null;
        applyAll();
        setTimeout(applyAll, 250);
      }, 30);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });

  document.addEventListener('click', function(e) {
    var t = e.target;
    if (t && t.closest && t.closest('[id^=es-], .es-popup-button, .es-sticky-btn, .es-cta-btn, .mobile-facets__open, .facets__summary')) {
      setTimeout(applyAll, 150);
      setTimeout(applyAll, 500);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  }
  applyAll();
  setTimeout(applyAll, 500);
  setTimeout(applyAll, 1500);
  setTimeout(applyAll, 3000);
  setTimeout(applyAll, 6000);

})();
